import axios from 'axios'
export const postAccountDetails = (data) =>
    axios({
        method: `post`,
        url: `/account-mgr/user`,
        data
    })
